import React, { useState, Fragment } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import * as R from "ramda";
import { GetAllFomMastik, InsertFomMastikData, changeFomMastikSearch } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { toggleNFomMastik } from "Constants/Constants";
import millimeterMask from "Components/Input/components/millimeterMask";
import { read } from "Helpers/LocalStorage";
import {DialogActions} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function InsertFomMastik() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const dispatch = useDispatch();
  const { fomMastikDataPagination } = useSelector((state) => ({
    fomMastikDataPagination: state.fomMastik.fomMastikDataPagination,
  }));
  const [controls, setControls] = useSetState({
    fomMastikType: {
      type: "toggle",
      arrayItems: toggleNFomMastik,
      value: toggleNFomMastik[0],
      validation: {
        required: true,
      },
    },
    nameFomMastik: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    cover: {
      type: "millimeter",
      value: 1,
      endIcon: "MeterLong",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        min: 1,
        notZero: true
      },
    },
    priceFomMastik: {
      type: "price",
      value: "0",
      endIcon: "moneyUnit",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onChangeToggle = async (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { nameFomMastik, cover, priceFomMastik, fomMastikType } = controls;
    //&& checkValid

    if (
      !R.isEmpty(formValid)  &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Price: +priceFomMastik.value,
          Name: nameFomMastik.value,
          Cover: cover.value,
          IdType: +fomMastikType.value.value,
        };
        await dispatch(InsertFomMastikData(data));
        dispatch(changeFomMastikSearch({ Name: "" }));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: fomMastikDataPagination.Limit,
          Page: 1,
        };
        await dispatch(GetAllFomMastik(params));
        handleDialog();
        onClear();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
        setLoading(false);
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
  };

  const onEnter = async () => {
    onClear();
  };

  const onClear = () => {
    setFormValid({});
    setCheckValid(false);
    setControls({ nameFomMastik: { value: "" } });
    setControls({ fomMastikType: { value: toggleNFomMastik[0] } });
    setControls({ cover: { value: 1 } });
    setControls({ priceFomMastik: { value: "0" } });
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newFomMastik"}/>}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"addNewFomMastik"}/>} </p>
          </div>
          <DialogContent>
            <Grid container spacing={2} className="d-flex mb-2">
              {
                Object.keys(controls).filter(key => controls[key].type === "toggle").map((key, index) => {
                  return (
                    <Grid item key={key + index} xs={12}>
                      <MuiRadioGroup
                        name={key}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio"
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
            <Grid container spacing={2} className="d-flex">
              {
                Object.keys(controls).filter(key => controls[key].type !== "toggle").map((key, index) => {
                  return (
                    <Grid item key={key + index} xs={12}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        inputComponent={controls[key].type === "millimeter" ? millimeterMask : ''}
                        endIcon={
                          controls[key].endIcon && (
                            <Translator id={controls[key].endIcon} />
                          )
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
                }
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default InsertFomMastik;
